/** Company lifecycle state pill. Matches the Companies-page palette
 *  beat-for-beat: active = green (--color-success), suspended is
 *  urgent-red, offboarded is muted (a terminal state, not an alarm).
 *  Shared by the AI Usage and Storage platform-admin tables so the
 *  status filter on each page has a matching visible column. */
export function StatusBadge({ status }) {
  return (
    <span
      className={
        // Solid fills in light mode; softened to the tinted-pill recipe in
        // dark mode (neutral tint + coloured text + hairline border) so they
        // don't glare against the dark surface.
        'inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold capitalize text-white border border-transparent dark:border-white/10 ' +
        (status === 'active'
          ? 'bg-[color:var(--color-success)] dark:bg-white/[0.06] dark:text-emerald-300'
          : status === 'offboarded'
            ? 'bg-[color:var(--color-ink-muted)] dark:bg-white/[0.06] dark:text-slate-300'
            : 'bg-[color:var(--color-priority-urgent)] dark:bg-white/[0.06] dark:text-rose-300')
      }
    >
      {status}
    </span>
  )
}
